/**
 * Use this to invalidate Apollo query results
 * Apollo query result invalidation is ONLY neccessary for inserts and deletes.
 * Try first to use Apollo cache for updates.
 *
 * Use this when passing props to refetch queries isn't straightforward.
 * This is mainly a better alternative to events.
 *
 * This is BAD:
 * In component modifying (inserting/deleting) the risolto_action table
 *   EventBus.$emit('fetchActions_ActionTable', {});
 *
 * In component querying the risolto_action table
 *   EventBus.$on('fetchActions_ActionTable', data => {
 *      this.fetchActions();
 *	  });
 *
 * Main drawback is that we tend to forget to unsubscribe to events
 *
 * This is OK:
 * In component modifying (inserting/deleting) the risolto_action table
 *   this.$store.commit('apollo/RISOLTO_ACTION');
 *
 * In component querying the risolto_action table
 *   '$store.state.apollo.risolto_action': function() {
 *      this.fetchActions();
 *	  }
 *
 */
const state = {
	risolto_action: true,
	risolto_channel_endpoint: true,
	risolto_contact: true,
	risolto_message: true
};

const mutations = {
	RISOLTO_ACTION: (state) => {
		state.risolto_action = !state.risolto_action;
	},
	RISOLTO_CHANNEL_ENDPOINT: (state) => {
		state.risolto_channel_endpoint = !state.risolto_channel_endpoint;
	},
	RISOLTO_CONTACT: (state) => {
		state.risolto_contact = !state.risolto_contact;
	},
	RISOLTO_MESSAGE: (state) => {
		state.risolto_message = !state.risolto_message;
	}
};

export default {
	namespaced: true,
	state,
	mutations
};
